export const inputHerePlaceholder = 'Įvesti';
export const selectHerePlaceholder = 'Pasirinkti';
export const nestedCheckboxValidationText =
  'Privaloma pasirinkti arba įvesti žemiau.';
export const schoolNameTooltipText = 'Mokyklos pavadinimas';
